import * as React from "react"
import { IUserInfo } from "../../types/appDataTypes"
import "./countryBox.scss"

interface ICounryOptionProps {
    country: IUserInfo["activeCountry"]
    background?: string
    onClick: (country: IUserInfo["activeCountry"]) => void
}
const CountryBox: React.FC<ICounryOptionProps> = (props) => {
    const { background, country, onClick } = props

    const countryList = {
        "SG": "Singapore",
        "TH": "Thailand",
        "MY": "Malaysia",
        "ID": "Indonesia",
        "VN": "Vietnam"
    }
    return (
        <div
            style={{ backgroundImage: `url(${background})` }}
            className="country-box"
            onClick={() => { if (onClick) { onClick(country) } }}
        >
            {countryList[country]}
        </div>
    )
}

export default CountryBox